import { Tag } from "@chakra-ui/react";
import { Status } from "@syla/shared/types/subscriptions/subscriptionState";
import React from "react";

interface PlanStatusTagProps {
  status: Status;
}

const statusColorMap: Record<Status, string> = {
  [Status.Active]: "green",
  [Status.DowngradeScheduled]: "yellow",
  [Status.Cancelled]: "red",
  [Status.Expired]: "red",
  [Status.RequiresAction]: "red",
};

export const PlanStatusTag = ({ status }: PlanStatusTagProps) => {
  return (
    <Tag variant="subtle" colorScheme={statusColorMap[status]}>
      {status}
    </Tag>
  );
};
